import styled from 'styled-components'
import { isMobile } from 'react-device-detect'

export const SingleSettingModalBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5%;
  background-image: linear-gradient(to right, #728ffb, #e896b1 98%);
  width: ${(props) => (props.width ? props.width : isMobile ? '100%' : '100%')};
  border-radius: 30px;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
`

export const UserDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 60%;
  align-self: center;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 2%;
  box-sizing: border-box;
  border-radius: 19px;
  box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.008),
    6.7px 6.7px 5.3px rgba(0, 0, 0, 0.012),
    12.5px 12.5px 10px rgba(0, 0, 0, 0.015),
    22.3px 22.3px 17.9px rgba(0, 0, 0, 0.018),
    41.8px 41.8px 33.4px rgba(0, 0, 0, 0.022),
    100px 100px 80px rgba(0, 0, 0, 0.03);

  @media only screen and (max-width: 600px) {
    width: 90%;
    margin-top: 3%;
  }
`
